window.onload = function() {
    let collectionSwatch = document.querySelectorAll('[data-swatch-url]');
    
    if(collectionSwatch.length === 0) {
        return;
    }

    document.body.classList.add('collection-loaded');

    collectionSwatch.forEach(function(swatch) {
        swatch.addEventListener('click', function(e) {
            e.preventDefault();

            // elements
            const product_card_el = swatch.closest('.product-listing');
            const swatch_li = swatch.closest('li');
            const image_el = product_card_el.querySelector('.product-image');
            const image_el2 = product_card_el.querySelector('.secondary-product-image');
            const color_heading_el = product_card_el.querySelector('.color-heading');
            const link_el = product_card_el.querySelector('.product-link');
            const link_el2 = product_card_el.querySelector('.product-link-2');
            const activeSwatch = product_card_el.querySelector('li.active');
            const product_price_el = product_card_el.querySelector('.product-price-container');

            // data
            const swatch_url = swatch.getAttribute('data-swatch-url');
            const swatch_image = swatch.getAttribute('data-swatch-image');
            const swatch_image2 = swatch.getAttribute('data-swatch-image-2');
            const swatch_full_title = swatch.getAttribute('data-swatch-full-title');
            const swatch_color_name = swatch.getAttribute('data-swatch-title');
            const swatch_price = swatch.getAttribute('data-swatch-price');
            const swatch_compare_at_price = swatch.getAttribute('data-swatch-compare-at-price');
            
            if(activeSwatch){
                activeSwatch.classList.remove('active');
            }
            swatch_li.classList.add('active');

            image_el.src = swatch_image;
            image_el2.src = swatch_image2;
            image_el.alt = swatch_full_title;
            image_el2.alt = swatch_full_title;
            link_el.href = swatch_url;
            link_el2.href = swatch_url;
            color_heading_el.innerText = swatch_color_name;

            if( swatch_compare_at_price ) {
                product_price_el.innerHTML = `<span data-product-price class="sale-price">${swatch_price}</span> <s data-compare-price="">${swatch_compare_at_price}</s>`;
            } else {
                product_price_el.innerHTML = `<span data-product-price>${swatch_price}</span>`;
            }
        });
    });
};
